export default "__VITE_ASSET__Dxyf23qA__"